module.exports = __webpack_public_path__ + "static/mypage_report_2020-ea154ffc2e57a41d02bb1f39f8352748.jpg";